import React, { useState } from 'react';
import { config } from '../../../config';
import styled from 'styled-components';
import { FullscreenLoader } from '../../../components/FullscreenLoader/FullscreenLoader';

const Iframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
`;

export const TaxForm = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    const onIframeLoaded = () => {
        setLoading(false);
    };

    return (
        <>
            {loading && <FullscreenLoader />}
            <Iframe src={config.baseUrl + '/appstore/tax-form'} onLoad={onIframeLoaded} />
        </>
    );
};
